import { useSetState } from 'ahooks'
import { DatePicker, Space } from 'antd'

import { ProDatetimePickerProps } from './interface'
import { SimpleModeSwitch } from './SimpleModeSwitch'
import { TimeDurationInput } from './TimeDurationInput'

const ALL_HOURS = Array.from({ length: 24 }, (_, i) => i)
const ALL_MINUTES = Array.from({ length: 60 }, (_, i) => i)
const ALL_SENCONDS = Array.from({ length: 60 }, (_, i) => i)

const getDisabledItems = (allItems: number[], excludeItems: number[]) => {
  return allItems.filter(item => !excludeItems.includes(item))
}

const createDisabledTime = ({
  simpleMode,
  hours,
  minutes,
  seconds
}: {
  simpleMode?: boolean
  hours?: number[]
  minutes?: number[]
  seconds?: number[]
}) => {
  return () => {
    if (simpleMode) {
      return {
        disabledHours() {
          return hours?.length ? getDisabledItems(ALL_HOURS, hours) : []
        },
        disabledMinutes() {
          return minutes?.length ? getDisabledItems(ALL_MINUTES, minutes) : []
        },
        disabledSeconds() {
          return seconds?.length ? getDisabledItems(ALL_SENCONDS, seconds) : []
        }
      }
    }
    return {}
  }
}

export const ProDatetimePicker = ({
  simpleMode: simpleModeConfig,
  duration: durationConfig,
  ...restProps
}: ProDatetimePickerProps) => {
  const {
    defaultEnable: defaultSimpleMode = false,
    hours,
    minutes,
    seconds
  } = simpleModeConfig || {}

  const { title: durationTitle = '', onChange: onDurationChange } =
    durationConfig || {}

  const [{ simpleMode, duration, disabledTime }, setState] = useSetState({
    simpleMode: defaultSimpleMode,
    duration: 0,
    disabledTime: createDisabledTime({
      simpleMode: defaultSimpleMode,
      hours,
      minutes,
      seconds
    })
  })

  const handleDurationChange = (duration: number) => {
    setState({ duration })
    onDurationChange?.(duration)
    handleSimpleModeChange(false)
  }

  const handleSimpleModeChange = (simpleMode: boolean) => {
    setState({
      simpleMode,
      disabledTime: createDisabledTime({
        simpleMode,
        hours,
        minutes,
        seconds
      })
    })
  }

  const handleOpenChange = (visible: boolean) => {
    if (!visible) {
      setState({
        duration: 0
      })
    }
  }

  return (
    <DatePicker
      {...restProps}
      disabledTime={disabledTime}
      picker='date'
      renderExtraFooter={() => (
        <Space
          orientation='vertical'
          size='middle'
          style={{ padding: `12px 0 `, lineHeight: 1 }}
        >
          {!!simpleModeConfig && (
            <SimpleModeSwitch
              value={simpleMode}
              onChange={handleSimpleModeChange}
            />
          )}
          {!!durationConfig && (
            <TimeDurationInput
              title={durationTitle}
              value={duration}
              onChange={handleDurationChange}
            />
          )}
        </Space>
      )}
      showTime={{
        hideDisabledOptions: true,
        disabledTime
      }}
      onOpenChange={handleOpenChange}
    />
  )
}
